<div class="tab-toolbar-wrapper">
  <div class="tab-toolbar">
    <mat-form-field appearance="fill">
      <mat-label>Measurement</mat-label>
      <mat-select [value]="selectedYear" (selectionChange)="onYearChange($event.value)">
        @for (year of measurements; track year) {
          <mat-option [value]="year" (click)="onYearOptionClick(year)">{{ year }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (showOtherMeasurement) {
      <mat-form-field appearance="fill">
        <mat-label>Other Measurement</mat-label>
        <mat-select [value]="otherMeasurement" (selectionChange)="onOtherMeasurementChange($event.value)">
          <mat-option value="">(None)</mat-option>
          @for (year of measurements; track year) {
            @if (year !== selectedYear) {
              <mat-option [value]="year">{{ year }}</mat-option>
            }
          }
        </mat-select>
      </mat-form-field>
    }

    @if (showKeywordsToggle) {
      <div class="keywords-wrapper">
        <mat-slide-toggle
          [checked]="keywordsVisible"
          (change)="onKeywordsToggle($event)"
          class="keywords-toggle">
        </mat-slide-toggle>
        <span class="keywords-label">Keywords</span>
      </div>
    }

    <span class="spacer"></span>

    <button
      mat-icon-button
      type="button"
      class="reload-button"
      matTooltip="Reload data"
      aria-label="Reload data"
      (click)="onReload()">
      <mat-icon>refresh</mat-icon>
    </button>

    @if (showSave && !isReadOnly()) {
      <button mat-flat-button color="primary" type="button" (click)="save.emit()" [disabled]="saveDisabled || isInactive()">
        <mat-icon>save</mat-icon>
        Save
      </button>
    }
  </div>

  <div class="tab-toolbar-content">
    @if (isReadOnly()) {
      <div class="readonly-notice">
        <mat-icon>visibility</mat-icon>
        <span>Read-only access — you can view this tab but not change it.</span>
      </div>
    }
    @if (inactivityMessage(); as message) {
      <div class="year-warning">
        <mat-icon>warning</mat-icon>
        <span>{{ message }}</span>
      </div>
    }
    <ng-content />
  </div>
</div>
